/**
 * Filtro dos cards indicadores da listagem de NF-es de entrada.
 * Todos = 0 nasce selecionado, para nunca ficar sem nenhum card ativo.
 */
export enum ResumoNotaFiscalEntradaEnum {
  Todos = 0,
  CapturadasHoje = 1,
  EmLancamento = 2,
  ComDivergencia = 3,
  LancadasMes = 4,
}
